import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-500 text-background-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-5 md:py-6">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Brand */}
          <Link to="/" className="inline-block group shrink-0">
            <img
              src="https://storage.helloreaddy.io/project_files/bb209c14-9fa9-4034-a099-af83f1204fe6/ed6231ec-ad64-40b6-9b06-9ed759a36c3f_compressed_ese.webp"
              alt="MORPHENIQ"
              className="h-16 md:h-20 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* CTA + Social */}
          <div className="flex items-center gap-4">
            <Link
              to="/shape-your-project"
              className="px-4 py-2 bg-secondary-500 text-foreground-950 text-sm font-semibold rounded-md hover:bg-secondary-400 transition-colors whitespace-nowrap"
            >
              {t('cta.shapeYourProject')}
            </Link>
            <Link
              to="/book-meeting"
              className="px-4 py-2 bg-purple-600 text-white text-sm font-semibold rounded-md hover:bg-purple-500 transition-colors whitespace-nowrap"
            >
              {t('cta.letsMeet')}
            </Link>

            {/* Social link */}
            <div className="flex items-center gap-1">
              <a
                href="https://www.linkedin.com/company/morpheniq"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="LinkedIn"
                className="w-8 h-8 flex items-center justify-center rounded-md text-background-200 hover:text-background-50 hover:bg-primary-600 transition-colors"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="max-w-7xl mx-auto mt-4 pt-4 border-t border-primary-400/30">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
            <a
              href="mailto:info@morpheniq.com"
              className="inline-flex items-center gap-1.5 text-xs text-background-200 hover:text-background-50 transition-colors"
            >
              <i className="ri-mail-line text-sm" />
              info@morpheniq.com
            </a>
            <span className="hidden sm:inline text-background-400/40">•</span>
            <p className="text-xs text-background-400/60">
              &copy; {new Date().getFullYear()} MORPHENIQ. {t('footer.rights')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}